var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPurpleLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1666 7.08333H14.9999C15.9166 7.08333 16.6666 7.83333 16.6666 8.75V17.0833C16.6666 18 15.9166 18.75 14.9999 18.75H4.99992C4.08325 18.75 3.33325 18 3.33325 17.0833V8.75C3.33325 7.83333 4.08325 7.08333 4.99992 7.08333H5.83325V5.41667C5.83325 3.11667 7.69992 1.25 9.99992 1.25C12.2999 1.25 14.1666 3.11667 14.1666 5.41667V7.08333ZM9.99992 2.91667C8.61659 2.91667 7.49992 4.03333 7.49992 5.41667V7.08333H12.4999V5.41667C12.4999 4.03333 11.3833 2.91667 9.99992 2.91667ZM4.99992 17.0833V8.75H14.9999V17.0833H4.99992ZM11.6666 12.9167C11.6666 13.8333 10.9166 14.5833 9.99992 14.5833C9.08325 14.5833 8.33325 13.8333 8.33325 12.9167C8.33325 12 9.08325 11.25 9.99992 11.25C10.9166 11.25 11.6666 12 11.6666 12.9167Z",
    fill: "#B6B0FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLock);
export default __webpack_public_path__ + "static/media/purple-lock.b173e52f79263120c72396b8987af4d5.svg";
export { ForwardRef as ReactComponent };